const ROOT = 'CipReport/filter/validationReportToken';

export const FETCH_VALIDATION_REPORT_TOKEN_REQUEST = `${ROOT}/FETCH_VALIDATION_REPORT_TOKEN_REQUEST`;
export const FETCH_VALIDATION_REPORT_TOKEN_SUCCESS = `${ROOT}/FETCH_VALIDATION_REPORT_TOKEN_SUCCESS`;
export const FETCH_VALIDATION_REPORT_TOKEN_FAILURE = `${ROOT}/FETCH_VALIDATION_REPORT_TOKEN_FAILURE`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
